import { render, staticRenderFns } from "./ShowNewRate.vue?vue&type=template&id=0d2ff485&"
import script from "./ShowNewRate.vue?vue&type=script&lang=js&"
export * from "./ShowNewRate.vue?vue&type=script&lang=js&"
import style0 from "./ShowNewRate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports